import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class PreguntasFrecuentes extends Component {

    componentDidMount(){
        document.title = "Ayuda | Preguntas frecuentes"

        var activeMenu = document.getElementById("preguntasFrec");
        activeMenu.classList.add("active");
    }

    componentWillUnmount(){
        document.getElementById("conoceSIJE").classList.remove("active");
        document.getElementById("FuncCasilla").classList.remove("active");
        document.getElementById("jornadaElec").classList.remove("active");
        document.getElementById("preguntasFrec").classList.remove("active");

        var colapsarMenu = document.getElementById("menuResponsivo");
        colapsarMenu.classList.replace("show", "not");
    }

    render () {
        return (
            <div className="container contenido">
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Preguntas frecuentes</span>
                    </small>
                </div>
                <div className="col-md-12 text-center">
                    <h1 className="tituloPagina">Preguntas Frecuentes</h1>
                </div>
                <div id="dudasFrecuentes">
                    <div className="renglon" id="duda1" data-toggle="collapse" data-target="#respuesta1" aria-controls="respuesta1">
                        ¿Cuál es el periodo de operación del SIJE?
                    </div>
                    <div className="collapse" id="respuesta1" aria-labelledby="duda1" data-parent="#dudasFrecuentes">
                        <p>Su operación se lleva a cabo el día de la Jornada Electoral. Comienza a operar desde las 7:00 horas del día de la elección y termina a las 3:00 horas del día siguiente.</p>
                    </div>

                    <div className="renglon" id="duda2" data-toggle="collapse" data-target="#respuesta2" aria-controls="respuesta2">
                        ¿Con qué frecuencia se actualiza la información mostrada por el portal SIJE?
                    </div>
                    <div className="collapse" id="respuesta2" aria-labelledby="duda2" data-parent="#dudasFrecuentes">
                        <p>La información que muestra el portal se actualiza cada 15 minutos.</p>
                    </div>

                    <div className="renglon" id="duda5" data-toggle="collapse" data-target="#respuesta5" aria-controls="respuesta5">
                        ¿Con qué frecuencia se actualiza la base de datos descargable en el portal SIJE?
                    </div>
                    <div className="collapse" id="respuesta5" aria-labelledby="duda5" data-parent="#dudasFrecuentes">
                        <p>El archivo <i>comprimido en zip</i> que contiene la base de datos se actualiza cada 30 minutos.</p>
                    </div>

                    <div className="renglon" id="duda3" data-toggle="collapse" data-target="#respuesta3" aria-controls="respuesta3">
                        ¿Quién provee la información mostrada en el portal?
                    </div>
                    <div className="collapse" id="respuesta3" aria-labelledby="duda3" data-parent="#dudasFrecuentes">
                        <p>La información es recopilada y transmitida, desde las casillas, por las y los Capacitadores Asistentes Electorales, vía voz o datos, al SIJE.</p>
                    </div>

                    {/* <div className="renglon" id="duda4" data-toggle="collapse" data-target="#respuesta4" aria-controls="respuesta4">
                        ¿Es posible que cambie el estatus de una casilla no instalada?
                    </div>
                    <div className="collapse" id="respuesta4" aria-labelledby="duda4" data-parent="#dudasFrecuentes">
                        <p>Existe la posibilidad de que una casilla reportada con el incidente: 1- Casilla no instalada, pueda cambiar su estatus a casilla instalada.</p>
                        <p>Las causas para que ocurra son muy variadas: recuperar un paquete electoral extraviado o robado, lograr la integración de la mesa directiva de casilla, etc.</p>
                    </div> */}
                </div>
            </div>
        )
    }
}

export default PreguntasFrecuentes;